
import React from 'react';

export default function Services() {
  const services = [
    {
      icon: 'ri-line-chart-line',
      title: 'Tax Strategy Planning',
      description:
        'Comprehensive long-term tax planning strategies tailored to your business goals, helping you make informed decisions that optimize your tax position year-round.',
      featured: true,
    },
    {
      icon: 'ri-building-line',
      title: 'Business Tax Preparation',
      description:
        'Expert preparation of corporate, partnership, and LLC tax returns with meticulous attention to detail and compliance.',
      featured: false,
    },
    {
      icon: 'ri-user-line',
      title: 'Individual Tax Filing',
      description:
        'Personalized tax preparation services for individuals, ensuring maximum deductions and credits while maintaining full compliance.',
      featured: false,
    },
    {
      icon: 'ri-shield-check-line',
      title: 'IRS Representation',
      description:
        'Professional representation and advocacy during IRS audits, appeals, and negotiations to protect your interests.',
      featured: false,
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Estate Planning',
      description:
        'Strategic estate and gift tax planning to preserve wealth for future generations while minimizing tax liabilities and ensuring smooth wealth transfer.',
      featured: true,
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Quarterly Reviews',
      description:
        'Regular financial check-ins to monitor tax obligations and adjust strategies as needed throughout the year.',
      featured: false,
    },
  ];

  return (
    <section id="services" className="py-24 px-8 bg-[#f8f9fb]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-8 h-px bg-[#00e5c7]"></div>
            <span className="text-[#00e5c7] text-xs uppercase tracking-[0.3em] font-semibold">
              Our Expertise
            </span>
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-[#0a1628]"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Comprehensive Tax Services
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className={`rounded-lg p-8 transition-all duration-300 hover:-translate-y-1 cursor-pointer group ${
                service.featured
                  ? 'bg-[#0a1628] text-white shadow-xl shadow-[#0a1628]/20 md:row-span-2'
                  : 'bg-white border border-gray-200/80 hover:border-[#00e5c7]/30 hover:shadow-lg'
              }`}
            >
              <div
                className={`w-14 h-14 rounded-lg flex items-center justify-center mb-6 ${
                  service.featured
                    ? 'bg-[#00e5c7]/15'
                    : 'bg-[#0a1628]/5 group-hover:bg-[#00e5c7]/10'
                } transition-colors`}
              >
                <i
                  className={`${service.icon} text-2xl ${
                    service.featured
                      ? 'text-[#00e5c7]'
                      : 'text-[#0a1628] group-hover:text-[#00e5c7]'
                  } transition-colors`}
                ></i>
              </div>
              <h3
                className={`text-xl font-bold mb-4 ${
                  service.featured ? 'text-white' : 'text-[#0a1628]'
                }`}
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                {service.title}
              </h3>
              <p
                className={`text-sm leading-relaxed mb-6 ${
                  service.featured ? 'text-white/70' : 'text-[#5a6a7e]'
                }`}
              >
                {service.description}
              </p>
              <a
                href="#contact"
                className={`inline-flex items-center text-sm font-semibold transition-colors cursor-pointer ${
                  service.featured
                    ? 'text-[#00e5c7] hover:text-[#00ccb0]'
                    : 'text-[#0a1628] group-hover:text-[#00e5c7]'
                }`}
              >
                Learn More
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
